import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-44ce9758"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "home-content"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://i.postimg.cc/fLy21sW8/header-bg.png"
}), /*#__PURE__*/_createElementVNode("h1", {
  class: "title"
}, "始终坚持一切为了人民"), /*#__PURE__*/_createElementVNode("p", null, "——习近平")], -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bgc"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "left-bg"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "md"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "right-bg"
})], -1));

const _hoisted_4 = {
  class: "news-wrapper"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "s-left"
};
const _hoisted_7 = {
  class: "s-info"
};
const _hoisted_8 = {
  class: "s-source"
};
const _hoisted_9 = {
  class: "add-time"
};
const _hoisted_10 = {
  class: "s-right"
};

const _hoisted_11 = /*#__PURE__*/_createTextVNode("END");

const _hoisted_12 = {
  key: 1,
  class: "loading",
  style: {
    "width": "100%",
    "height": "100%"
  }
};

const _hoisted_13 = /*#__PURE__*/_createTextVNode("加载中...");

const _hoisted_14 = {
  key: 2,
  class: "err-box"
};
const _hoisted_15 = {
  key: 3,
  class: "footer"
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "footer-content"
}, [/*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("span", null, "献给那些"), /*#__PURE__*/_createElementVNode("span", null, "死于过度防疫的"), /*#__PURE__*/_createElementVNode("span", null, "人们")])], -1));

const _hoisted_17 = [_hoisted_16];
import { ref, onMounted, onActivated } from "vue";
import { useRouter } from "vue-router"; // 获取分页数据

import { getPageData } from "../getData";
export default {
  __name: 'index',

  setup(__props) {
    const router = useRouter();
    const {
      newsData,
      errStatus
    } = getPageData();
    const homeRef = ref(null);
    const scrollVal = ref(0);
    const loading = ref(false);
    const finished = ref(false); // 滚动时，保存最新的scrollTop值

    onMounted(() => {
      homeRef.value.addEventListener("scroll", e => {
        scrollVal.value = e.target.scrollTop;
      });
    }); // 缓冲组件激活时触发这个钩子

    onActivated(() => homeRef.value.scrollTop = scrollVal.value);

    const scrollTo = value => {
      if (value == 0) {
        scrollVal.value = value;
      } else {
        const scrollBottomVal = homeRef.value.scrollHeight - homeRef.value.clientHeight;
        scrollVal.value = scrollBottomVal;
      }

      homeRef.value.scrollTo({
        top: scrollVal.value,
        behavior: "smooth"
      });
    };

    const getNewsInfo = id => {
      router.push({
        path: `/news_info/${id}`
      });
    };

    let pageNum = ref(0); // 滑动到页面底部执行

    const onLoad = () => {
      // 模拟分页加载数据
      setTimeout(() => {
        pageNum.value += 1;

        if (pageNum.value < newsData.value.length) {
          newsData.value[0].page.push(...newsData.value[pageNum.value].page); // 加载状态结束

          loading.value = false;
          return;
        } // 数据全部加载完成


        finished.value = true;
      }, 800);
    };

    const themeVars = {
      dividerMargin: "10px 0"
    };
    return (_ctx, _cache) => {
      const _component_van_list = _resolveComponent("van-list");

      const _component_van_divider = _resolveComponent("van-divider");

      const _component_van_loading = _resolveComponent("van-loading");

      const _component_van_empty = _resolveComponent("van-empty");

      const _component_van_config_provider = _resolveComponent("van-config-provider");

      const _directive_lazy = _resolveDirective("lazy");

      return _openBlock(), _createBlock(_component_van_config_provider, {
        "theme-vars": themeVars,
        style: {
          "width": "100%",
          "height": "100%"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "home",
          ref_key: "homeRef",
          ref: homeRef
        }, [_unref(newsData).length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createElementVNode("section", _hoisted_4, [_createElementVNode("ul", null, [_createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[0] || (_cache[0] = $event => loading.value = $event),
          finished: finished.value,
          onLoad: onLoad,
          "immediate-check": false,
          offset: "50"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(newsData)[0].page, (item, i) => {
            return _openBlock(), _createElementBlock("li", {
              key: item.id,
              onClick: $event => getNewsInfo(item.id),
              class: _normalizeClass({
                'last-li': i == _unref(newsData)[0].page.length - 1
              })
            }, [_createElementVNode("div", null, [_createElementVNode("article", null, [_createElementVNode("section", _hoisted_6, [_createElementVNode("h4", null, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(item.source), 1), _createElementVNode("span", _hoisted_9, _toDisplayString("添加时间:" + item.date), 1)])]), _createElementVNode("section", _hoisted_10, [_withDirectives(_createElementVNode("img", null, null, 512), [[_directive_lazy, item.small_img]])])])])], 10, _hoisted_5);
          }), 128))]),
          _: 1
        }, 8, ["loading", "finished"])]), _withDirectives(_createVNode(_component_van_divider, {
          style: {
            color: '#cccccc',
            borderColor: '#cccccc'
          }
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 1
        }, 512), [[_vShow, finished.value]])]), _createElementVNode("section", {
          class: _normalizeClass(["fixIcon", {
            show: scrollVal.value >= 500
          }])
        }, [_createElementVNode("a", {
          href: "javascript:",
          class: "fixTop-ico",
          onClick: _cache[1] || (_cache[1] = $event => scrollTo(0))
        }), _createElementVNode("a", {
          href: "javascript:",
          class: "fixBottom-ico",
          onClick: _cache[2] || (_cache[2] = $event => scrollTo(1))
        })], 2)])) : _createCommentVNode("", true), !_unref(newsData).length && !_unref(errStatus) ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_van_loading, {
          type: "spinner",
          vertical: ""
        }, {
          default: _withCtx(() => [_hoisted_13]),
          _: 1
        })])) : _createCommentVNode("", true), _unref(errStatus) ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_van_empty, {
          image: "error",
          description: "请求失败，请刷新网页重试！"
        })])) : _createCommentVNode("", true), _unref(newsData).length && !_unref(errStatus) ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17)) : _createCommentVNode("", true)], 512)]),
        _: 1
      });
    };
  }

};